import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthBehaviors } from '@core/services/token/token-behaviors';
import { TokenService } from '@core/services/token/token.service';

export const unauthenticatedGuard: CanActivateFn = async () => {
  if (inject(TokenService).getIsLoggedIn()) {
    inject(Router).navigateByUrl(inject(AuthBehaviors).current.postLoginRedirect);

    return false;
  }

  return true;
};

